import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { SnackbarProvider } from "notistack";
import { I18nextProvider, initReactI18next } from 'react-i18next'
import i18n from "./translation/i18n";
const root = document.getElementById("root");

ReactDOM.hydrate(
  
  <SnackbarProvider maxSnack={1} autoHideDuration={2000}>
    <I18nextProvider i18n={i18n}>
    <App />
    </I18nextProvider>
  </SnackbarProvider>
  ,
  root,
  () => {}
);
